export const SYSTEM_USER = { id: '', fullName: 'Система', shortName: 'Система' };
export const SYSTEM_USER_ID = '2d2206ae-5e28-448b-8245-ed7ae041fe63';
